import { getCscLocationBasedDigitalExists, getDigitalRentalWoFirstService } from '../selectors/coreApi';
import { getRentalVehicleLocation } from '../selectors/rentalMission';
import { VEHICLE_OTHER_LOCATION } from '../enums';
import { isMissionInProgress } from './coreApi';

export const isCscLocationDigitalExit = state => {
  const allowsDigitalRental =
    getDigitalRentalWoFirstService(state) &&
    getCscLocationBasedDigitalExists(state).includes(VEHICLE_OTHER_LOCATION.OTHER) &&
    !isMissionInProgress(state);

  if (allowsDigitalRental) {
    return false;
  }

  const cscDigitalExit = getCscLocationBasedDigitalExists(state);
  const rentalLocation = getRentalVehicleLocation(state);

  return cscDigitalExit?.includes(rentalLocation);
};
